<!-- 欢迎语 -->
<template>
  <div class="container">
    <el-dialog
      title="选择欢迎语"
      :visible.sync="show"
      append-to-body
      width="550px"
      class="welcome-dialog"
      style="'margin-top:50vh;'"
      :close-on-click-modal="false"
      @close="cancelHandle()"
    >
      <div style="padding: 10px 0;">
        <el-input
          placeholder="输入关键词"
          size="small"
          @blur="searchHandle"
          @clear="searchHandle"
          v-model="keywords"
          clearable
          style="width: 100%;"
        >
          <el-button slot="append" icon="el-icon-search" @click="searchHandle()"></el-button
        ></el-input>
      </div>
      <ul class="welcome-list">
        <li
          v-for="(item, index) in welcomeList"
          :key="item.welcomeId"
          class="welcome-item"
          :class="{ 'welcome-select': item.isSelect }"
          @click="selectWelcome(index, item)"
        >
          {{ item.welcomeContent }}
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelHandle()">取 消</el-button>
        <el-button type="primary" size="small" @click="confirmHandle()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getWelcome } from "@/api/activeCode/activeCode.js";
export default {
  name: "WelcomeDia",
  props: ["welcomeDislogVisible"],
  data() {
    return {
      show: false,
      keywords: "", //搜索关键词
      welcomeList: [], //欢迎语集合
      selectResult: {}, //选中的欢迎语
      tempWelcomeList: [],
    };
  },
  created() {},
  watch: {
    welcomeDislogVisible(val) {
      this.show = val;
      if (val) {
        if (this.keywords) {
          this.keywords = "";
        }
        this.selectResult = {};
        this.getWelcome();
      }
    },
  },
  methods: {
    // 获取欢迎语
    getWelcome() {
      getWelcome({}, localStorage.getItem("Authorization"),true)
        .then((res) => {
          if (res.error.code == 200) {
            let result = res.data.records;
            result.map((v) => {
              v.isSelect = false;
            });
            this.welcomeList = Object.assign([], result);
            this.tempWelcomeList = this.welcomeList;
          }
        })
        .catch((err) => {});
    },
    //搜索
    searchHandle() {
      this.welcomeList = this.tempWelcomeList.filter((v) => {
        v.isSelect = false;
        return v.welcomeContent.indexOf(this.keywords) != -1;
      });
    },
    //取消
    cancelHandle() {
      this.$emit("welcomeCloseHandle");
    },
    //确认
    confirmHandle() {
      this.$emit("welcomeConfirmHandle", this.selectResult);
    },
    //选中欢迎语
    selectWelcome(index, data) {
      this.welcomeList.map((v) => {
        v.isSelect = false;
      });
      this.welcomeList[index].isSelect = true;
      this.selectResult = {
        welcomeContent: data.welcomeContent,
        welcomeId: data.welcomeId,
      };
    },
  },
};
</script>
<style lang="scss">
.welcome-dialog {
  .welcome-list {
    padding: 6px 0;
    margin: 0;
    max-height: 450px;
    overflow: auto;
    .welcome-item {
      padding: 8px;
      border-width: 1px 0px;
      border-style: solid;
      border-color: #dcdfe6;
      margin-bottom: 6px;
      cursor: pointer;
    }
    .welcome-item:hover {
      background: #d0f1ff;
    }
    .welcome-select {
      background: #d0f1ff;
    }
  }
}
</style>
